export default {
      id: "ic_share_black_white-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_share_black_white-usage",
      toString: function () {
        return this.url;
      }
    }